import { LoadingButtonProps } from '@mui/lab/LoadingButton';

// ----------------------------------------------------------------------

export function loadingButton() {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: LoadingButtonProps }) => ({
          ...(ownerState.variant === 'soft' && {
            '& .MuiLoadingButton-loadingIndicatorStart': {
              left: 10
            },
            '& .MuiLoadingButton-loadingIndicatorEnd': {
              right: 14
            },
            ...(ownerState.size === 'small' && {
              '& .MuiLoadingButton-loadingIndicatorStart': {
                left: 10
              },
              '& .MuiLoadingButton-loadingIndicatorEnd': {
                right: 10
              }
            })
          })
        })
      }
    }
  };
}
